import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import { Accessor } from "./Accessor";

var mapValues = require("lodash/mapValues");

var zipObject = require("lodash/zipObject");

var constant = require("lodash/constant");

export var HighlightAccessor =
/*#__PURE__*/
function (_Accessor) {
  _inherits(HighlightAccessor, _Accessor);

  function HighlightAccessor(fields) {
    var _this;

    _classCallCheck(this, HighlightAccessor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HighlightAccessor).call(this));
    _this.fields = fields;
    _this.highlightFields = _this.computeHighlightedFields(fields);
    return _this;
  }

  _createClass(HighlightAccessor, [{
    key: "computeHighlightedFields",
    value: function computeHighlightedFields(fields) {
      return {
        fields: mapValues(zipObject(fields), constant({}))
      };
    }
  }, {
    key: "buildOwnQuery",
    value: function buildOwnQuery(query) {
      return query.setHighlight(this.highlightFields);
    }
  }]);

  return HighlightAccessor;
}(Accessor);